import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { auth } from '../actions';

import wordmark from '../pinstripe-wordmark.png';

class UpdatePassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      newPassword: '',
    };
  }
  componentDidMount() {
    window.analytics.page('Update Password Viewed');
  }

  handleOldPassword = e => {
    this.setState({ oldPassword: e.target.value });
  }

  handleNewPassword = e => {
    this.setState({ newPassword: e.target.value });
  }

  resetForm = () => {
    this.setState({ oldPassword: '', newPassword: '' });
  }

  onSubmit = e => {
    e.preventDefault();
    this.props.updatepassword(this.state.oldPassword, this.state.newPassword);
    if (!this.props.errors.length > 0) {
      window.analytics.track('Updated Password');
      this.props.history.go(-1);
    }

    // this.props.history.push('/apps');
  }

  handleClose = e => {
    this.props.history.go(-1);
  }

  render() {
    let required = true;
    
    if (this.props.isAuthenticated) {
      this.props.history.go(-1);
    }
    return (
      <div className="auth">
        <form onSubmit={this.onSubmit}>
          <Link className="btn_close" to="" onClick={this.handleClose}>
            <i className="fa fa-angle-right"></i>
            <i className="fa fa-angle-left"></i>
          </Link>
          <fieldset>
            <legend>
              <img src={wordmark} className="App-logo" alt="pinstripe wordmark" />
            </legend>
            {this.props.errors.length > 0 && (
              <ul>
                {this.props.errors.map(error => (
                  <li key={error.field}>{error.message}</li>
                ))}
              </ul>
                )}
            <p>
              <label htmlFor="password">Enter Current Password</label>
              <input
                type="password" id="old_password" name="old_password"
                required={required}
                onChange={this.handleOldPassword}/>
            </p>
            <p>
              <label htmlFor="password">Set New Password</label>
              <input
                type="password" id="new_password" name="new_password"
                required={required}
                onChange={this.handleNewPassword}/>
            </p>
            <p>
              <button className="btn" type="submit">Update Password</button>
            </p>
          </fieldset>
        </form>
        <div className="side-img"></div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let errors = [];
  if (state.auth.errors) {
    errors = Object.keys(state.auth.errors).map(field => {
      return {field, message: state.auth.errors[field]};
    });
  }
  return {
    errors,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    updatepassword: (oldpassword, newpassword) => {
      return dispatch(auth.updatepassword(oldpassword, newpassword));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePassword);


// WEBPACK FOOTER //
// ./src/components/UpdatePassword.js